if (!customElements.get('wishlist-remove-button')) {
  class WishlistRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.key = 'wishlist-handles';
      this.handle = this.dataset.productHandle;
      this.querySelector('button').addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      event.preventDefault();
      const handles = localStorage.getItem(this.key).split(',');
      localStorage.setItem(this.key, handles.filter(handle => handle !== this.handle).join(','));
      this.closest('wishlist-item').parentElement.remove();
    }
  }

  customElements.define('wishlist-remove-button', WishlistRemoveButton);
}
